import React, { useState } from 'react';
import { AddEventFirstStep } from './AddEventFirstStep';
import { AddEventSecondStep } from './AddEventSecondStep';

export const AddEvent = () => {
  const[step, setStep] = useState(1)

  const moveToNextStep = () => {
    setStep(step => step + 1);
  }

  switch (step) {
    case 2:
      return <AddEventSecondStep />;
    default:
      return <AddEventFirstStep moveToNextStep={moveToNextStep} />;
  }
};
